import type {Moment} from 'moment-timezone'
import moment from 'moment-timezone'
import {mmap} from '@freckle/maybe'
import type {Metadata} from './metadata'

export type ArticleMetadataT = {
  articleUuid: string
  articleLevelId: string
  startsAt: Moment | undefined | null
}

export type ResumableArticleMetadataT = {
  coinsEarned: number
} & ArticleMetadataT

type ArticlesWritingTag =
  'science_articles_writing' | 'social_studies_articles_writing' | 'ela_articles_writing'

export function fromOpenApiArticlesWritingMetadata(
  x: Metadata<ArticlesWritingTag>
): ArticleMetadataT {
  return {
    ...x,
    startsAt: mmap(moment, x.startsAt)
  }
}

type ArticlesReadingTag =
  'science_articles_reading' | 'social_studies_articles_reading' | 'ela_articles_reading'

export function fromOpenApiArticlesReadingMetadata(
  x: Metadata<ArticlesReadingTag>
): ResumableArticleMetadataT {
  return {
    ...x,
    startsAt: mmap(moment, x.startsAt)
  }
}
